import React from 'react';
import { Switch, Route } from 'react-router';
import pages from './pages';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';
import NotFound from '../pages/NotFound';

const Routes = (): JSX.Element => {
  return (
    <Switch>
      {pages.map((route, i) => {
        if (route.auth) {
          return <PrivateRoute key={i} {...route} />;
        }

        return <PublicRoute key={i} {...route} />;
      })}
      <Route component={NotFound} />
    </Switch>
  );
};

export default Routes;
